
<div class="config-panel" :key="selectedObjectModelTrigger ? selectedObjectModelTrigger.client_id : 'None'" v-bind:class="{ 'element-selected': (selectedObjectModelTrigger)}">

  <row class="panel-title">
    <prefix>
      <button class="btn-icon gravel-to-blue collapse-settings" @click="configPanelCollapse()" type="button">
        <span class="sr-only">Collapse/Reveal Configuration Panel</span>
        <span class="icon arrow-double"></span>
      </button>
    </prefix>
    <column>
      <h4 class="dark">
        Configuration Panel
      </h4>
    </column>
  </row>

  <template v-if="selectedObjectModelTrigger">
    <row class="panel-title">
      <prefix>
        <icon :class="selectedObjectModelTrigger.icon"></icon>
      </prefix>
      <column>
        <h5 class="dark">
          {{ selectedObjectModelTrigger.displayName }}
        </h5>
      </column>
    </row>

    <scroll-area class="panel">
      <div class="control-group">
        <control-group group-name="Define">
          <tab-define></tab-define>
        </control-group>
        <control-group group-name="Configure">
          <tab-configure></tab-configure>
        </control-group>
      </div>
    </scroll-area>
  </template>

  <div v-else class="empty-box">
    <p>Select an event to configure it.</p>
  </div>

</div>

